import { ILoading } from '../../../shared/models/other/store/Loading.interface';

export interface IGeneralState {
    loading: ILoading;
}

export const initialGeneralState: IGeneralState = {
    loading: null
};
